import React from 'react';

function NoPage() {
    return (
        <h1>Nothing to show!</h1>
    );
}

export default NoPage;